(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-lifecycle-lifecycle-common.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-lifecycle-lifecycle-common.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'androidx-savedstate-savedstate'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'androidx-savedstate-savedstate'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-common'] === 'undefined') {
      throw new Error("Error loading module 'androidx-savedstate-savedstate'. Its dependency 'androidx-lifecycle-lifecycle-common' was not found. Please, check whether 'androidx-lifecycle-lifecycle-common' is loaded prior to 'androidx-savedstate-savedstate'.");
    }
    globalThis['androidx-savedstate-savedstate'] = factory(typeof globalThis['androidx-savedstate-savedstate'] === 'undefined' ? {} : globalThis['androidx-savedstate-savedstate'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-lifecycle-lifecycle-common']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_lifecycle_lifecycle_common) {
  'use strict';
  //region block: imports
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var equals = kotlin_kotlin.$_$.sf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var isInterface = kotlin_kotlin.$_$.rg;
  var LifecycleEventObserver = kotlin_androidx_lifecycle_lifecycle_common.$_$.a;
  var hashCode = kotlin_kotlin.$_$.bg;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var Event_ON_STOP_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.j;
  var Event_ON_START_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.i;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var KtMap = kotlin_kotlin.$_$.g7;
  var State_INITIALIZED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.m;
  var State_STARTED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.o;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var toMutableMap = kotlin_kotlin.$_$.rc;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.i4;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForClass(sam$androidx_lifecycle_LifecycleEventObserver$0, 'sam$androidx_lifecycle_LifecycleEventObserver$0', VOID, VOID, [LifecycleEventObserver, FunctionAdapter]);
  initMetadataForClass(SavedStateRegistryImpl, 'SavedStateRegistryImpl');
  initMetadataForClass(SavedState, 'SavedState');
  initMetadataForInterface(SavedStateProvider, 'SavedStateProvider');
  initMetadataForClass(SavedStateRegistry, 'SavedStateRegistry');
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(SavedStateRegistryController, 'SavedStateRegistryController');
  initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
  //endregion
  function keyOrValueNotFoundError(key) {
    throw IllegalArgumentException_init_$Create$("No valid saved state was found for the key '" + key + "'. It may be missing, null, or not of " + 'the expected type. This can occur if the value was saved with a different type or if the saved state was modified unexpectedly.');
  }
  function Companion() {
    this.h7m_1 = 'androidx.lifecycle.BundlableSavedStateRegistry.key';
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function sam$androidx_lifecycle_LifecycleEventObserver$0(function_0) {
    this.i7m_1 = function_0;
  }
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).j70 = function (source, event) {
    return this.i7m_1(source, event);
  };
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).q3 = function () {
    return this.i7m_1;
  };
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, LifecycleEventObserver) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_lifecycle_LifecycleEventObserver$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function SavedStateRegistryImpl$_init_$lambda_jhqb6s() {
    return Unit_instance;
  }
  function SavedStateRegistryImpl$performAttach$lambda(this$0) {
    return function (_unused_var__etf5q3, event) {
      var tmp;
      if (event.equals(Event_ON_START_getInstance())) {
        this$0.q7m_1 = true;
        tmp = Unit_instance;
      } else if (event.equals(Event_ON_STOP_getInstance())) {
        this$0.q7m_1 = false;
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SavedStateRegistryImpl(owner, onAttach) {
    var tmp;
    if (onAttach === VOID) {
      tmp = SavedStateRegistryImpl$_init_$lambda_jhqb6s;
    } else {
      tmp = onAttach;
    }
    onAttach = tmp;
    this.j7m_1 = owner;
    this.k7m_1 = onAttach;
    this.l7m_1 = new SynchronizedObject();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.m7m_1 = LinkedHashMap_init_$Create$();
    this.n7m_1 = false;
    this.o7m_1 = null;
    this.p7m_1 = false;
    this.q7m_1 = true;
  }
  protoOf(SavedStateRegistryImpl).r7m = function (key) {
    // Inline function 'kotlin.check' call
    if (!this.p7m_1) {
      var message = "You can 'consumeRestoredStateForKey' only after the corresponding component has moved to the 'CREATED' state";
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var tmp0_elvis_lhs = this.o7m_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var state = tmp;
    // Inline function 'androidx.savedstate.read' call
    var $this$read = _SavedStateReader___init__impl__k2stzo(state);
    var consumed = SavedStateReader__contains_impl_ig4u69($this$read, key) ? SavedStateReader__getSavedState_impl_l38yfa($this$read, key) : null;
    // Inline function 'androidx.savedstate.write' call
    var $this$write = _SavedStateWriter___init__impl__99cr38(state);
    SavedStateWriter__remove_impl_9y9m5w($this$write, key);
    // Inline function 'androidx.savedstate.read' call
    var $this$read_0 = _SavedStateReader___init__impl__k2stzo(state);
    if (SavedStateReader__isEmpty_impl_ep4h1z($this$read_0)) {
      this.o7m_1 = null;
    }
    return consumed;
  };
  protoOf(SavedStateRegistryImpl).s7m = function (key, provider) {
    // Inline function 'androidx.savedstate.internal.synchronized' call
    // Inline function 'androidx.savedstate.internal.synchronizedImpl' call
    this.l7m_1;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.m7m_1;
    // Inline function 'kotlin.require' call
    if (!!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(key)) {
      var message = 'SavedStateProvider with the given key is already registered';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.set' call
    this.m7m_1.z2(key, provider);
  };
  protoOf(SavedStateRegistryImpl).t7m = function (key) {
    // Inline function 'androidx.savedstate.internal.synchronized' call
    // Inline function 'androidx.savedstate.internal.synchronizedImpl' call
    this.l7m_1;
    var tmp0 = this.m7m_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = tmp0.s1().t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlin.collections.component1' call
        var k = element.t1();
        // Inline function 'kotlin.collections.component2' call
        var provider = element.u1();
        var result = k === key ? provider : null;
        if (!(result == null)) {
          tmp$ret$3 = result;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    return tmp$ret$3;
  };
  protoOf(SavedStateRegistryImpl).u7m = function (key) {
    // Inline function 'androidx.savedstate.internal.synchronized' call
    // Inline function 'androidx.savedstate.internal.synchronizedImpl' call
    this.l7m_1;
    this.m7m_1.a3(key);
  };
  protoOf(SavedStateRegistryImpl).v7m = function () {
    // Inline function 'kotlin.check' call
    if (!this.j7m_1.w7m().v70().equals(State_INITIALIZED_getInstance())) {
      var message = "Restarter must be created only during owner's initialization stage";
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.check' call
    if (!!this.n7m_1) {
      var message_0 = 'SavedStateRegistry was already attached.';
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    this.k7m_1();
    var tmp = this.j7m_1.w7m();
    var tmp_0 = SavedStateRegistryImpl$performAttach$lambda(this);
    tmp.t70(new sam$androidx_lifecycle_LifecycleEventObserver$0(tmp_0));
    this.n7m_1 = true;
  };
  protoOf(SavedStateRegistryImpl).x7m = function (savedState) {
    if (!this.n7m_1) {
      this.v7m();
    }
    // Inline function 'kotlin.check' call
    if (!!this.j7m_1.w7m().v70().r70(State_STARTED_getInstance())) {
      var message = 'performRestore cannot be called when owner is ' + this.j7m_1.w7m().v70().toString();
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.check' call
    if (!!this.p7m_1) {
      var message_0 = 'SavedStateRegistry was already restored.';
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    var tmp = this;
    var tmp_0;
    if (savedState == null) {
      tmp_0 = null;
    } else {
      // Inline function 'androidx.savedstate.read' call
      var $this$read = _SavedStateReader___init__impl__k2stzo(savedState);
      tmp_0 = SavedStateReader__contains_impl_ig4u69($this$read, 'androidx.lifecycle.BundlableSavedStateRegistry.key') ? SavedStateReader__getSavedState_impl_l38yfa($this$read, 'androidx.lifecycle.BundlableSavedStateRegistry.key') : null;
    }
    tmp.o7m_1 = tmp_0;
    this.p7m_1 = true;
  };
  protoOf(SavedStateRegistryImpl).y7m = function (outBundle) {
    // Inline function 'androidx.savedstate.savedState' call
    var initialState = emptyMap();
    var copiedState = toMutableMap(initialState);
    // Inline function 'kotlin.apply' call
    var this_0 = new SavedState(copiedState);
    // Inline function 'androidx.savedstate.write' call
    var $this$savedState = _SavedStateWriter___init__impl__99cr38(this_0);
    var tmp0_safe_receiver = this.o7m_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      SavedStateWriter__putAll_impl_no0lvi($this$savedState, tmp0_safe_receiver);
    }
    // Inline function 'androidx.savedstate.internal.synchronized' call
    // Inline function 'androidx.savedstate.internal.synchronizedImpl' call
    this.l7m_1;
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.m7m_1.s1().t();
    while (_iterator__ex2g4s.u()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.t1();
      // Inline function 'kotlin.collections.component2' call
      var provider = _destruct__k2r9zo.u1();
      SavedStateWriter__putSavedState_impl_5xy7ov($this$savedState, key, provider.z7m());
    }
    var inState = this_0;
    // Inline function 'androidx.savedstate.read' call
    var $this$read = _SavedStateReader___init__impl__k2stzo(inState);
    if (!SavedStateReader__isEmpty_impl_ep4h1z($this$read)) {
      // Inline function 'androidx.savedstate.write' call
      var $this$write = _SavedStateWriter___init__impl__99cr38(outBundle);
      SavedStateWriter__putSavedState_impl_5xy7ov($this$write, 'androidx.lifecycle.BundlableSavedStateRegistry.key', inState);
    }
  };
  function SavedState(map) {
    var tmp;
    if (map === VOID) {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp = LinkedHashMap_init_$Create$();
    } else {
      tmp = map;
    }
    map = tmp;
    this.a7n_1 = map;
  }
  function _SavedStateReader___init__impl__k2stzo(source) {
    return source;
  }
  function _get_source__4cuw5s($this) {
    return $this;
  }
  function SavedStateReader__getSavedState_impl_l38yfa($this, key) {
    var tmp = _get_source__4cuw5s($this).a7n_1.w2(key);
    var tmp0_elvis_lhs = tmp instanceof SavedState ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      keyOrValueNotFoundError(key);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  function SavedStateReader__getSavedStateOrNull_impl_pv2mts($this, key) {
    var tmp = _get_source__4cuw5s($this).a7n_1.w2(key);
    return tmp instanceof SavedState ? tmp : null;
  }
  function SavedStateReader__isEmpty_impl_ep4h1z($this) {
    return _get_source__4cuw5s($this).a7n_1.r();
  }
  function SavedStateReader__contains_impl_ig4u69($this, key) {
    return _get_source__4cuw5s($this).a7n_1.u2(key);
  }
  function SavedStateReader__toMap_impl_49zebr($this) {
    // Inline function 'kotlin.collections.buildMap' call
    // Inline function 'kotlin.collections.buildMapInternal' call
    var capacity = _get_source__4cuw5s($this).a7n_1.n1();
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = _get_source__4cuw5s($this).a7n_1.x2().t();
    while (_iterator__ex2g4s.u()) {
      var key = _iterator__ex2g4s.v();
      this_0.z2(key, _get_source__4cuw5s($this).a7n_1.w2(key));
    }
    return this_0.t5();
  }
  function SavedStateProvider() {
  }
  function SavedStateRegistry(impl) {
    this.b7n_1 = impl;
  }
  protoOf(SavedStateRegistry).r7m = function (key) {
    return this.b7n_1.r7m(key);
  };
  protoOf(SavedStateRegistry).s7m = function (key, provider) {
    this.b7n_1.s7m(key, provider);
  };
  protoOf(SavedStateRegistry).t7m = function (key) {
    return this.b7n_1.t7m(key);
  };
  protoOf(SavedStateRegistry).u7m = function (key) {
    this.b7n_1.u7m(key);
  };
  function Companion_0() {
  }
  protoOf(Companion_0).c7n = function (owner) {
    return new SavedStateRegistryController(new SavedStateRegistryImpl(owner));
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function SavedStateRegistryController(impl) {
    this.d7n_1 = impl;
    this.e7n_1 = new SavedStateRegistry(this.d7n_1);
  }
  protoOf(SavedStateRegistryController).v7m = function () {
    this.d7n_1.v7m();
  };
  protoOf(SavedStateRegistryController).f7n = function (savedState) {
    this.d7n_1.x7m(savedState);
  };
  protoOf(SavedStateRegistryController).g7n = function (outBundle) {
    this.d7n_1.y7m(outBundle);
  };
  function _SavedStateWriter___init__impl__99cr38(source) {
    return source;
  }
  function _get_source__4cuw5s_0($this) {
    return $this;
  }
  function SavedStateWriter__putSavedState_impl_5xy7ov($this, key, value) {
    // Inline function 'kotlin.collections.set' call
    _get_source__4cuw5s_0($this).a7n_1.z2(key, value);
  }
  function SavedStateWriter__putAll_impl_no0lvi($this, from) {
    _get_source__4cuw5s_0($this).a7n_1.b3(from.a7n_1);
  }
  function SavedStateWriter__remove_impl_9y9m5w($this, key) {
    _get_source__4cuw5s_0($this).a7n_1.a3(key);
  }
  function SynchronizedObject() {
  }
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = SavedStateProvider;
  _.$_$.b = SavedState;
  _.$_$.c = _SavedStateReader___init__impl__k2stzo;
  _.$_$.d = SavedStateReader__contains_impl_ig4u69;
  _.$_$.e = SavedStateReader__getSavedStateOrNull_impl_pv2mts;
  _.$_$.f = SavedStateReader__isEmpty_impl_ep4h1z;
  _.$_$.g = SavedStateReader__toMap_impl_49zebr;
  _.$_$.h = _SavedStateWriter___init__impl__99cr38;
  _.$_$.i = SavedStateWriter__putAll_impl_no0lvi;
  _.$_$.j = SavedStateWriter__putSavedState_impl_5xy7ov;
  _.$_$.k = SavedStateWriter__remove_impl_9y9m5w;
  _.$_$.l = Companion_instance_0;
  //endregion
  return _;
}));

//# sourceMappingURL=androidx-savedstate-savedstate.js.map
